import React, { useState, useContext } from "react";
import {
  IonAvatar,
  IonCard,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonPage,
  IonTitle,
  IonToolbar,
  IonLoading,
  IonAlert,
  IonSegment,
  IonSegmentButton,
} from "@ionic/react";
import TimeClock from "../components/TimeClock";
import { businessOutline, logOut, sunny, moon, cafe } from "ionicons/icons";
import "./Tab1.css";

import axios from "../utils/axiosInstance";
// import getlocation from '../lib/geolocation'
import { Plugins, CameraResultType } from "@capacitor/core";
import { AppContext } from "../context";

interface clock {
  clockIn: number;
  clockOut: number;
}

const Home: React.FC = () => {
  const TITLE = process.env.REACT_APP_TITLE;
  const { Geolocation, Camera } = Plugins;

  // const [clock, setClock] = useState({ clockIn: null, clockOut: null });
  const [showLoading, setShowLoading] = useState(false);
  const [alert, setAlert] = useState({
    isOpen: false,
    // header: '通知',
    message: "預設訊息",
  });
  const [type, setType] = useState<any>("A");
  const context: any = useContext(AppContext);
  // const [cycling, setCycling] = useState([]);
  //Replaces componentDidMount and componentWillUnmount
  console.log(context);

  function alertGeolocationError(error:any) {
    const { code } = error;
    switch (code) {
      case 1:
        // PERMISSION_DENIED
        setAlert({
          isOpen: true,
          message: "打卡系統無權使用你的位置。",
        });
        break;
      case 2:
        // POSITION_UNAVAILABLE
        setAlert({
          isOpen: true,
          message: "地理位置資訊回傳了錯誤。",
        });
        break;
      case 3:
        // TIMEOUT
        setAlert({
          isOpen: true,
          message: "取得定位逾時。",
        });
        break;
      default:
        setAlert({
          isOpen: true,
          message: "發生不明錯誤，請再次嘗試。",
        });
        break;
    }

  }

  async function takePicture() {
    const image = await Camera.getPhoto({
      quality: 90,
      allowEditing: true,
      resultType: CameraResultType.Uri,
    });
    // image.webPath will contain a path that can be set as an image src.
    // You can access the original file using image.path, which can be
    // passed to the Filesystem API to read the raw data of the image,
    // if desired (or pass resultType: CameraResultType.Base64 to getPhoto)
    var imageUrl = image.webPath;
    // Can be set to the src of an image now
    // imageElement.src = imageUrl;
    console.log(imageUrl);
  }

  async function clockIn() {
    setShowLoading(true);
    try {
      const position = await Geolocation.getCurrentPosition();
      const memberId = window.localStorage.getItem("memberId");
      axios({
        method: "POST",
        url: `/gateway/private/core/v1/time-records/member/${memberId}`,
        data: {
          type: type + "01",
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        },
      })
        .then(({ data }) => {
          console.log(data);
          setShowLoading(false);
          if (data.returnCode === "000000") {
            setAlert({
              isOpen: true,
              message: "打卡成功。",
            });
          }
        })
        .catch((err) => {
          setShowLoading(false);
          setAlert({
            isOpen: true,
            message: `系統未預期錯誤(${err})`
          });
          console.error(err);
        });
    } catch (error) {
      // Get Geolocation Error
      setShowLoading(false);
      alertGeolocationError(error);
    }
  }
  async function clockOut() {
    setShowLoading(true);
    const memberId = window.localStorage.getItem("memberId");
    let position = {
      coords: {
        latitude: 0,
        longitude: 0,
      },
    };
    try {
      position = await Geolocation.getCurrentPosition();
      const headers = {
        "X-Access-Token": window.localStorage.getItem("token"),
      };
      console.log(position);
      axios({
        method: "POST",
        url: `/gateway/private/core/v1/time-records/member/${memberId}`,
        headers,
        data: {
          type: type + "02",
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        },
      })
        .then(({ data }) => {
          console.log(data);
          setShowLoading(false);
          if (data.returnCode === "000000") {
            setAlert({
              isOpen: true,
              message: "打卡成功。",
            });
          } else if (data.returnCode === "100400") {
            setAlert({
              isOpen: true,
              message: data.info,
            });
          } else {
            setAlert({
              isOpen: true,
              message: `系統未預期錯誤(${data.returnCode})`,
            });
          }
        })
        .catch((err) => {
          setShowLoading(false);
          console.error(err);
        });
    } catch (error) {
      // Get Geolocation Error
      setShowLoading(false);
      alertGeolocationError(error);
    }
    // takePicture()
  }

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>{TITLE}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonLoading isOpen={showLoading} message={"請稍候......"} />
        <IonAlert
          isOpen={alert.isOpen}
          header={"通知"}
          message={alert.message}
          buttons={["關閉"]}
          onWillDismiss={() => {
            alert.isOpen = false;
          }}
        />
        <div className="ion-padding-horizontal">
          <TimeClock></TimeClock>
        </div>
        <IonCard>
          <IonCardHeader>
            <IonCardSubtitle>Welcome.</IonCardSubtitle>
            <IonCardTitle>
              Mr./Ms. {context.state.profile.legalName}
            </IonCardTitle>
          </IonCardHeader>
        </IonCard>
        <IonSegment
          value={type}
          color="secondary"
          onIonChange={(e) => setType(e.detail.value)}
        >
          <IonSegmentButton value="A">
            <IonIcon size="large" icon={sunny} />
            <IonLabel>Morning</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value="B">
            <IonIcon size="large" icon={cafe} />
            <IonLabel>Afternoon</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value="C">
            <IonIcon size="large" icon={moon} />
            <IonLabel>Night</IonLabel>
          </IonSegmentButton>
        </IonSegment>
        <br />
        <IonItem button onClick={clockIn}>
          <IonAvatar slot="start">
            <IonIcon color="primary" size="large" icon={businessOutline} />
          </IonAvatar>
          <IonLabel>打卡上班</IonLabel>
        </IonItem>
        <IonItem button onClick={clockOut}>
          <IonAvatar slot="end">
            <IonIcon color="danger" size="large" icon={logOut} />
          </IonAvatar>
          <IonLabel>打卡下班</IonLabel>
        </IonItem>
      </IonContent>
    </IonPage>
  );
};

export default Home;
